/**
 * useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.
 */
import {useEffect, useState} from "react";

function useHasWindow(): boolean {
  const [hasWindow, setHasWindow] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      !hasWindow && setHasWindow(true);
    }
  }, []);

  return hasWindow;
}

export default useHasWindow;
